import { CommonModule } from '@angular/common';
import {
  Component,
  ContentChild,
  ContentChildren,
  Directive,
  EventEmitter,
  Input,
  Output,
  QueryList,
  TemplateRef,
  Optional,
  NgModule,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { PageState } from '@app/pipes/page-state/page-state';
import { PipesModule } from '@app/pipes/pipes.module';

import { cardContentAnimation, enterAnimation } from '../animations';
import { OmguiSummaryRowModule } from '../omgui/omgui-summary-row/omgui-summary-row.component';

@Directive({
  selector: '[om-card-list-empty-state-body]',
})
export class CardListEmptyStateBodyDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
  selector: '[om-card-list-row]',
})
export class CardListRowDirective {
  @Input() link: string;
  @Output() actionClicked = new EventEmitter<void>();
  @Input() useAction: boolean;

  constructor(@Optional() public templateRef: TemplateRef<any>) {}

  handleClick(event: MouseEvent) {
    if (this.actionClicked && !this.link) {
      event.preventDefault();
      this.actionClicked.emit();
    }
  }
}

@Directive({
  selector: '[om-card-list-header]',
})
export class CardListHeaderDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
  selector: '[om-card-list-header-link]',
})
export class CardListHeaderLinkDirective {
  @Output() actionClicked = new EventEmitter<void>();

  constructor(public templateRef: TemplateRef<any>) {}

  handleClick(event: MouseEvent) {
    event.preventDefault();
    this.actionClicked.emit();
  }
}

@Directive({
  selector: 'om-card-list-empty-state',
})
export class CardListEmptyStateDirective {
  @ContentChild(CardListHeaderDirective) header: CardListHeaderDirective;
  @ContentChild(CardListEmptyStateBodyDirective) body: CardListEmptyStateBodyDirective;
}

@Directive({
  selector: 'om-card-list-section',
})
export class CardListSectionDirective {
  @ContentChild(CardListHeaderDirective) header: CardListHeaderDirective;
  @ContentChildren(CardListRowDirective) rows: QueryList<CardListRowDirective>;
  constructor() {}
}

@Component({
  selector: 'om-card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['../../shared/card.scss', './card-list.component.scss'],
  animations: [enterAnimation, cardContentAnimation],
})
export class CardListComponent {
  @ContentChild(CardListHeaderDirective) header: CardListHeaderDirective;
  @ContentChild(CardListHeaderLinkDirective) headerLink: CardListHeaderLinkDirective;
  @ContentChild(CardListEmptyStateDirective) emptyState: CardListEmptyStateDirective;
  @ContentChildren(CardListRowDirective) rows: QueryList<CardListRowDirective>;
  @ContentChildren(CardListSectionDirective) sections: QueryList<CardListSectionDirective>;
  @Input() pageState: PageState = PageState.SUCCESS;
  @Input() useLoadingSkeleton = false;

  readonly successState = PageState.SUCCESS;

  get bottomBorderHidden() {
    return !this.rows?.last?.link;
  }

  isEmptyState() {
    return this.rows.length === 0 && this.sections.toArray().every(section => section.rows.length === 0);
  }
}

@NgModule({
  declarations: [
    CardListEmptyStateBodyDirective,
    CardListHeaderDirective,
    CardListHeaderLinkDirective,
    CardListEmptyStateDirective,
    CardListRowDirective,
    CardListSectionDirective,
    CardListComponent,
  ],
  imports: [CommonModule, PipesModule, RouterModule, OmguiSummaryRowModule],
  exports: [
    CardListEmptyStateBodyDirective,
    CardListHeaderDirective,
    CardListHeaderLinkDirective,
    CardListEmptyStateDirective,
    CardListRowDirective,
    CardListSectionDirective,
    CardListComponent,
  ],
})
export class CardListModule {}
